export {
  API_BASE_URL,
  ACCOUNTS_BASE_URL,
  accountsHost,
  ApiError,
  logout,
} from "./client";

export type * from "./types";
export type { Entitlements, PlanOption, PlansResponse } from "./billing";
export type { Alert, AlertType } from "./activity";

import { accountApi } from "./account";
import { sitesApi } from "./sites";
import { editorApi } from "./editor";
import { buildsApi } from "./builds";
import { startApi } from "./start";
import { adminApi } from "./admin";
import { claimApi } from "./claim";
import { billingApi } from "./billing";
import { activityApi } from "./activity";

export const api = {
  ...accountApi,
  ...sitesApi,
  ...editorApi,
  ...buildsApi,
  ...startApi,
  ...adminApi,
  ...claimApi,
  ...billingApi,
  ...activityApi,
};
